import Promise from 'promise';
import Fingerprint from './fingerprint.js'
import md5 from 'crypto-js/md5';

var _getFingerprintPromise = null;
export default function () {
  if (!_getFingerprintPromise) {
    _getFingerprintPromise = new Promise(resolve => {
      Fingerprint.get(function (res) {
        var cache = {};
        res.forEach(function (obj) {
          if (obj.key !== '_2') {
            cache[obj.key] = obj.value || '';
          }
        });
        if (Array.isArray(cache._9)) {
          cache._9[1] = md5(cache._9[1] || '').toString();
        }
        if (Array.isArray(cache._6)) {
          cache._6[0] = md5(cache._6[0] || '').toString();
        }
        cache = md5(JSON.stringify(cache)).toString();
        resolve(cache);
      });
    });
  }
  return _getFingerprintPromise;
}
